<div
    class="date-picker-multiselect"
    [ngClass]="{ active: !readonly, 'not-valid': isNotValid }"
>
    <div class="row navigation">
        <div class="col-md-3">
            <i class="fa fa-arrow-left" (click)="onPreviousYearClicked()"></i>
        </div>
        <div class="col-md-6">{{ month.format("YYYY") }}</div>
        <div class="col-md-3">
            <i class="fa fa-arrow-right" (click)="onNextYearClicked()"></i>
        </div>
    </div>
    <div class="row navigation">
        <div class="col-md-3">
            <i class="fa fa-arrow-left" (click)="onPreviousMonthClicked()"></i>
        </div>
        <div class="col-md-6">{{ month.format("MMMM") }}</div>
        <div class="col-md-3">
            <i class="fa fa-arrow-right" hznTestId="date-picker-next-month" (click)="onNextMonthClicked()"></i>
        </div>
    </div>
    <div class="row no-gutters">
        <div class="col-sm day-header">Sun</div>
        <div class="col-sm day-header">Mon</div>
        <div class="col-sm day-header">Tue</div>
        <div class="col-sm day-header">Wed</div>
        <div class="col-sm day-header">Thu</div>
        <div class="col-sm day-header">Fri</div>
        <div class="col-sm day-header">Sat</div>
    </div>
    @for (item of days | groupBy: "week"; track item) {
        <div class="row no-gutters">
            @for (day of item.value; track day) {
                <div
                    class="col-sm day {{ getDayClass(day) }}"
                    [ngClass]="{ 'day-selected': isSelected(day) }"
                    [hznTestId]="'date-picker-day-' + day.date.format('YYYY-MM-DD')"
                    (click)="onSelectClicked(day)"
                >
                    {{ day.date.format("DD") }}
                </div>
            }
        </div>
    }
</div>
